import script from "./Third.vue?vue&type=script&setup=true&lang=js"
export * from "./Third.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__